import { createContext, useContext } from 'react';

/**
 * Context for lead actions (convert to case, close lead)
 * Provides dialog trigger functions to child components
 */
const LeadActionsContext = createContext(null);

/**
 * Hook to access lead action functions
 * Must be used within LeadActionsProvider (BoardContent)
 *
 * @returns {Object} - { openConvertCase, openCloseLead }
 */
export const useLeadActions = () => {
  const context = useContext(LeadActionsContext);
  if (!context) {
    throw new Error('useLeadActions must be used within LeadActionsProvider');
  }
  return context;
};

export default LeadActionsContext;
